export default __webpack_public_path__ + "static/media/boy8.3d17d2e8.jpg";